/**
 * Structure containing the customer experience information
 */
import {RawServerResponse} from "./raw-server-response";

export interface UXContext {
    /**
     * 2-character country code, for example "DE"
     */
    chatDestinationCountry: string,
    /**
     * True if the country-switch modal should be shown
     */
    countrySwitchIsNeeded: boolean,
    /**
     * URL to the national site
     */
    countrySwitchTarget: string,
    /**
     * True if the user should be blocked
     */
    isBlocked: boolean,
    queryParams: string,
    refererPath: string,
    references: {
        [region: string]: {
            [location: string]: {
                url: string
                website: string
            }
        }
    },
    switchCountryModalDescription: string,
    switchCountryModalHomeCountryButtonEventLabel: string,
    switchCountryModalHomeCountryButtonLabel: string,
    switchCountryModalInternationalButtonEventLabel: string,
    switchCountryModalInternationalButtonLabel: string,
    switchCountryModalTitle: string,
    /**
     * Actions to be taken by the system, depending on additional environment parameters (e.g. isBlocked field)
     */
    systemActions: string[],
    targetLocation?: string,
    targetRegion?: string,
}

export function getDefaultContext(): UXContext & RawServerResponse {
    const response: UXContext = {
        chatDestinationCountry: "",
        countrySwitchIsNeeded: false,
        countrySwitchTarget: "",
        isBlocked: false,
        queryParams: "",
        refererPath: "",
        references: {},
        switchCountryModalDescription: "",
        switchCountryModalHomeCountryButtonEventLabel: "",
        switchCountryModalHomeCountryButtonLabel: "",
        switchCountryModalInternationalButtonLabel: "",
        switchCountryModalInternationalButtonEventLabel: "",
        switchCountryModalTitle: "",
        systemActions: [],
    };
    const rawResponseString = JSON.stringify(Object.assign({}, response, {systemActions: '[]'}));
    const rawResponse: RawServerResponse = {
        rawResponseObject: JSON.parse(rawResponseString),
        rawResponseString,
    };

    return Object.assign({}, response, rawResponse);
}
